<template>
  <div class="phone-country-field">
    <el-select
      class="phone-country-field__country"
      :value="normalizedCountry"
      filterable
      default-first-option
      :placeholder="countryPlaceholder || $t('admin.add.selectcountry')"
      :filter-method="filterCountry"
      popper-class="phone-country-dropdown"
      @visible-change="onVisibleChange"
      @change="onCountryChange"
    >
      <el-option
        v-for="item in options"
        :key="item.iso + '-' + item.value"
        :label="item.label"
        :value="item.value"
      >
        <span class="phone-country-option">
          <span class="phone-country-option__name">{{ item.name }}</span>
          <span class="phone-country-option__code">+{{ item.value }}</span>
        </span>
      </el-option>
    </el-select>
    <el-input
      class="phone-country-field__number"
      :value="phone"
      :placeholder="phonePlaceholder || $t('admin.add.phone')"
      maxlength="15"
      clearable
      @input="onPhoneInput"
    />
  </div>
</template>

<script>
import { buildCountryOptions, normalizeCountryCode } from "@/utils/countryCodes";

export default {
  name: "PhoneCountryField",
  props: {
    country: {
      type: [Number, String],
      default: 86,
    },
    phone: {
      type: [Number, String],
      default: "",
    },
    countryPlaceholder: {
      type: String,
      default: "",
    },
    phonePlaceholder: {
      type: String,
      default: "",
    },
  },
  data() {
    const list = buildCountryOptions(this.$i18n && this.$i18n.locale);
    return {
      allOptions: list,
      options: list,
    };
  },
  computed: {
    normalizedCountry() {
      return normalizeCountryCode(this.country);
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.allOptions = buildCountryOptions(this.$i18n.locale);
      this.options = this.allOptions;
    },
  },
  methods: {
    filterCountry(query) {
      const q = String(query || "")
        .trim()
        .toLowerCase()
        .replace(/^\+/, "");
      if (!q) {
        this.options = this.allOptions;
        return;
      }
      this.options = this.allOptions.filter(function (item) {
        return item.search.indexOf(q) !== -1;
      });
    },
    onVisibleChange(open) {
      if (!open) {
        this.options = this.allOptions;
      }
    },
    onCountryChange(val) {
      this.$emit("update:country", normalizeCountryCode(val));
    },
    onPhoneInput(val) {
      this.$emit("update:phone", val);
    },
  },
};
</script>

<style scoped>
.phone-country-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.phone-country-field__country {
  flex: 0 0 240px;
  width: 240px;
}

.phone-country-field__country >>> .el-input,
.phone-country-field__country >>> .el-input__inner {
  width: 100%;
}

.phone-country-field__number {
  flex: 1;
  min-width: 0;
}

@media (max-width: 767.98px) {
  .phone-country-field {
    flex-direction: column;
    align-items: stretch;
  }

  .phone-country-field__country {
    flex: none;
    width: 100%;
  }
}
</style>

<style>
.phone-country-dropdown {
  min-width: 280px !important;
}

.phone-country-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.phone-country-option__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 12px;
}

.phone-country-option__code {
  color: #8492a6;
  font-size: 13px;
  flex-shrink: 0;
}
</style>
